import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';

import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';
import { JobsService } from 'src/app/shared/services/jobs.service';
import { JobDetail } from 'src/app/shared/models/gql/job-detail.model';
import { PlatformBackButtonService } from 'src/app/shared/services/platform-back-button.service';

@Component({
  selector: 'app-consumer-booked-job',
  templateUrl: './consumer.page.html',
  styleUrls: ['./consumer.page.scss'],
})
export class ConsumerBookedJobPage implements OnInit {
  public job: JobDetail;

  // url to navigate to forcefully
  public forcedUrl = '';

  constructor(
    public navCtrl: NavController,
    public auth: AuthService,
    private route: ActivatedRoute,
    public jobsService: JobsService,
    private platformBackButtonService: PlatformBackButtonService,
  ) {}

  ngOnInit() {
    // Get job details.
    this.getJobDetails();

    // If consumer is coming to this booked LMJ page from open LMJ page,
    // they need to redirect back to redirectUrl instead of open LMJ page when back button is clicked.
    this.forcedUrl = this.route.snapshot.queryParamMap.get('redirectUrl') || '';
  }

  ionViewDidEnter() {
    // subscribe to the platform back button which forced the default back navigation
    this.platformBackButtonService.addForcedRedirection(this.forcedUrl);
  }

  ionViewDidLeave() {
    // unsubscribe to the platform back button
    this.platformBackButtonService.removeForcedRedirection();
  }

  /**
   * Get job details.
   *
   */
  private async getJobDetails() {
    const { paramMap } = this.route.snapshot;
    const jobId = Number(paramMap.get('id'));
    try {
      this.job = await this.jobsService.getPostedJobDetailsById(jobId);
    } catch (error) {
      console.error(error);
    }
  }
}
